<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="contract-list">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @changeMethod="changeMethod"
        @searchBtnClick="searchTrigger"
      ></SiruiSearch>
      <div class="main-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="loading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="tableColumns"
          rowKey="id"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <span v-if="item.field == 'contractStatus'">{{
                getName('contractStatus', row[item.field])
              }}</span>
              <span v-else-if="item.field == 'paymentMethodName'">{{
                getName('paymentMethodName', row[item.field])
              }}</span>
              <span v-else>{{ row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <ChangeSubjectDialog
        ref="changeSubjectRef"
        :row="this.multipleSelection"
        @changeSubject="close"
      ></ChangeSubjectDialog>
      <DeleteContractDialog
        ref="deleteContractRef"
        @operateSuccess="resetBtnClick"
        :deleteIds="deleteIds"
      ></DeleteContractDialog>
      <CloseContractDialog
        ref="closeContractRef"
        :id="this.id"
        :isPaid="this.isPaid"
        :isCreate="this.isCreate"
        @closeOver="resetBtnClick"
      ></CloseContractDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns } from './columns/searchColumns';
  import { defaultTableColumns } from './index.js';
  import ChangeSubjectDialog from './components/changeSubjectDialog.vue';
  import DeleteContractDialog from './components/deleteContractDialog.vue';
  import tableMixins from '@/common/mixins/table.js';
  import listBtnGroupMixin from '../mixins/listBtnGroupMixin';
  import CloseContractDialog from '../contractMaintainance/components/closeContractDialog.vue';
  import API from '@/api/park/contract';
  import baseApi from '@/api/dataBase';
  import goodsApi from '@/api/masterData/goods.js';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'contractList',
    mixins: [tableMixins, listBtnGroupMixin],
    data() {
      return {
        loading: false,
        tableColumns: [],
        isPaid: true, //判断合同是否已完成结算
        queryData: {
          contractNo: null,
          contractStatus: null,
          customerNameOne: null,
          customerCodeOne: null,
          dateStart: null,
          dateEnd: null,
          signatoryName: null,
          signingDate: null,
          contractPlace: null,
          warehouseName: null,
          goodsTypeName: null,
          paymentMethodName: null,
          paperContractNo: null,
          remarks: null,
          parkCompanyCode: null,
          businessDepartmentCode: null,
        },
        menuButtonList: [], // 表格功能按钮
        tableData: [], // 表格数据
        multipleSelection: [],
        selectedItems: [],
        goodsTypeList: [],
        contractStatusList: [],
        deleteIds: [],
        departmentCode: '',
        companyCode: '',
        paymentMethodNameList: [], //付款方式列表
        id: null,
        closeAttachments: [],
        contractNo: null,
        isCreate: true, //判断该合同是否已创建结算单
        companyList: [],
        departmentList: [],
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      this.getTableData();
      this.getButtonList();
      this.getGoodsParentApi();
      this.contractStatusList = this.dictListMap.warehouseContractStatus;
      this.paymentMethodNameList = this.dictListMap.receiveMethod;
      this.departmentCode = this.userInfo.userInfo.departmentCode;
      this.companyCode = this.userInfo.userInfo.companyCode;
      console.log(this.userInfo.userInfo, '当前登陆人信息');
      this.getCompany();
      this._getCompanyApi();
    },
    methods: {
      // 根据合同号获取结算单列表
      async getSettlementList() {
        if (this.contractNo) {
          const { data } = await this.$axios.post(API.QUERY_SETTLEMENT_LIST, {
            contractNo: this.contractNo,
          });
          if (!data.data.length) {
            this.isCreate = false;
          } else {
            data.data.map((item) => {
              if (item.settlementIssueStatus != '01' || item.receiveStatus != '01') {
                this.isPaid = false;
              }
            });
          }

          console.log('data获取结算单列表', data);
        }
      },
      // 根据合同号获取结算列表
      // 获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      async getCompany() {
        const { data } = await this.$axios.get(`${baseApi.LISTDATA_SERECHCOMPANY}/${1}`);
        console.log(data, '获取公司列表');
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 获取表格数据
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.queryData,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          // parkCompanyCode: this.userInfo.userInfo.companyCode,
          // businessDepartmentCode: this.userInfo.userInfo.departmentCode,
          // parkDepartmentCode: this.userInfo.userInfo.departmentCode,
        };
        const { data } = await this.$axios.post(API.LIST_CONTRACT_BY_PAGE, postData);
        this.isLoading = false;
        if (data.code == 0) {
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.tableData = data.data.list;
        } else {
          this.$message.error('查询表格数据失败');
          this.tableData = [];
        }
      },
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        this.id = row.length ? row[0].id : null;
        this.contractNo = row.length ? row[0].contractNo : null;
        console.log(row);
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let query = { ...this.queryData, pageSize, pageNum };
        return query;
      },
      // 获取商品大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.userInfo.companyCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
        });
        console.log(data.data, '商品类型全部');
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              parentProductNo: item.parentProductNo,
              value: item.id,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null || value == '') {
          return '';
        }
        let item;
        if (type == 'contractStatus') {
          if (!this.contractStatusList.length) {
            return value;
          }
          item = this.contractStatusList.find((item) => item.value == value);
          return item.label;
        } else if (type == 'paymentMethodName') {
          if (!this.paymentMethodNameList.length) {
            return value;
          }
          item = this.paymentMethodNameList.find((item) => item.value == value);
          return item.label;
        }
      },
      changeMethod(row) {
        if (row.prop == 'customerNameOne') {
          this.queryData.customerNameOne = row.val[0].partnerZhName;
        } else if (row.prop == 'warehouseName') {
          this.queryData.warehouseName = row.val[0].storageName;
        } else if (row.prop == 'projectCode') {
          this.queryData.projectCode = row.val[0].projectCode;
        } else if (row.prop == 'parkCompanyCode') {
          this.queryData.parkCompanyCode = row.val;
          this.queryData.businessDepartmentCode = null;
          console.log(row);
          // const item = this.companyList.find((item) => item.personCompanyCode == val);
          // 获取部门数据
          this._getDepartmentByCompanyCodeApi(row.val);
        }
      },
      // 获取公司
      async _getCompanyApi() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            this.companyList = res.data.data.personCompanyInfo || [];
            // 设置默认选中
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(code) {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
    components: {
      SiruiSearch,
      ChangeSubjectDialog,
      DeleteContractDialog,
      CloseContractDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
